import { StatColumn, StatProps, Text, TextVariant } from "@bridgesplit/ui";
import { formatUsd } from "@bridgesplit/utils";
import { COPY } from "app/constants";

import { useVaultContext } from "../VaultContext";
import { useVaultWithdrawContext } from "./VaultWithdrawContext";

const variant: TextVariant = "body1";
export default function VaultWithdrawStats() {
    const { form } = useVaultWithdrawContext();
    const { userPosition } = useVaultContext();
    const postWithdrawUsd = useGetPostWithdrawUsd();

    if (!userPosition) return null;

    const stats: StatProps[] = [
        {
            caption: COPY.USER_POSITION_TERM,
            value: [
                <Text translate="no">{formatUsd(userPosition.amountAvailable.amountUsd)}</Text>,
                <Text translate="no">{formatUsd(postWithdrawUsd)}</Text>
            ],
            hide: !form.amountPrincipal
        }
    ];

    return <StatColumn variant={variant} stats={stats} />;
}

/**
 * Lp amount is typically rising constantly. So when you click max withdraw we don't want to userPosition.amountAvailable.amountUsd - usdValue
 * because after a few seconds the after balance will grow to pennies, which creates a bad UX.
 *
 * So if isMaxWithdraw is set, and the amount isn't restricted by a vault limit, then just show 0,
 * because the BE is going to zero out the account.
 */
function useGetPostWithdrawUsd() {
    const { form } = useVaultWithdrawContext();
    const { vaultExpanded, userPosition } = useVaultContext();

    if (!vaultExpanded || !userPosition) return undefined;

    const usdValue = vaultExpanded?.principalOracle.getUsdAmount(form.amountPrincipal);

    return form.isMaxWithdraw ? 0 : Math.max(0, userPosition.amountAvailable.amountUsd - (usdValue ?? 0));
}
